module.exports = __webpack_public_path__ + "img/Back1.44da212.svg";